import { render, staticRenderFns } from "./GuideBookPaperAroundCard.vue?vue&type=template&id=2d6eee17&scoped=true"
import script from "./GuideBookPaperAroundCard.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperAroundCard.vue?vue&type=script&lang=js"
import style0 from "./GuideBookPaperAroundCard.vue?vue&type=style&index=0&id=2d6eee17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6eee17",
  null
  
)

export default component.exports